require("core-js/modules/esnext.global-this.js");
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("tooltip", [], e) : "object" == typeof exports ? exports.tooltip = e() : t.tooltip = e();
}(this, function () {
  return function () {
    var t = {
        583: function _(t, e, n) {
          var o, i, r;
          void 0 !== n.g ? n.g : this.window || this.global, i = [], void 0 === (r = "function" == typeof (o = function () {
            "use strict";

            var t = {},
              e = "data-tooltip",
              n = "flix-tooltip--active",
              o = ["click", "hover"],
              i = function i(t, e) {
                e.hasAttribute("hidden") ? r(t, e) : c(t, e);
              },
              r = function r(t, e) {
                e.removeAttribute("hidden"), e.classList.add(n), t.setAttribute("aria-expanded", "true");
              },
              c = function c(t, e) {
                e.classList.remove(n), e.setAttribute("hidden", ""), t.setAttribute("aria-expanded", "false");
              },
              u = function u(t) {
                document.querySelectorAll("." + n).forEach(function (n) {
                  var o = n.parentElement.querySelector("[" + e + '="' + n.id + '"]');
                  null === o || null === n || n.parentElement.contains(t.target) || c(o, n);
                });
              },
              a = function a(t, e) {
                var n = e.querySelector(".flix-tooltip__close");
                (function (t, e) {
                  t.addEventListener("click", function () {
                    i(t, e);
                  }), "BUTTON" !== t.tagName && t.addEventListener("keydown", function (n) {
                    " " !== n.key && 32 !== n.keyCode && "Enter" !== n.key && 13 !== n.keyCode || i(t, e);
                  });
                })(t, e), "hover" === function (t) {
                  var e = t.getAttribute("data-event");
                  return e && o.indexOf(e.toLowerCase()) >= 0 ? e : "click";
                }(t) && function (t, e) {
                  var n;
                  t.addEventListener("mouseenter", function () {
                    clearTimeout(n), n = setTimeout(r, "300", t, e);
                  }), [t, e].forEach(function (o) {
                    o.addEventListener("mouseleave", function (o) {
                      e.contains(o.relatedTarget) || e.contains(document.activeElement) || (clearTimeout(n), n = setTimeout(c, "300", t, e));
                    });
                  });
                }(t, e), n && n.addEventListener("click", function () {
                  c(t, e), t.focus();
                }), [t, e].forEach(function (n) {
                  n.addEventListener("keydown", function (n) {
                    "Escape" !== n.key && 27 !== n.keyCode || (c(t, e), t.focus());
                  });
                });
              };
            return t.init = function () {
              document.querySelectorAll("[" + e + "]").forEach(function (t) {
                var n = t.getAttribute(e),
                  o = document.getElementById(n);
                null === o ? console.warn("tooltip.js plugin error: Cannot find element with id " + n + " for target " + t) : (function (t, e) {
                  var n = e.getAttribute("id"),
                    o = e.hasAttribute("hidden");
                  e.setAttribute("role", "tooltip"), t.setAttribute("aria-describedby", n), t.setAttribute("aria-controls", n), t.setAttribute("aria-expanded", !o);
                }(t, o), a(t, o));
              }), document.removeEventListener("click", u), document.addEventListener("click", u);
            }, t;
          }()) ? o.apply(e, i) : o) || (t.exports = r);
        }
      },
      e = {};
    function n(o) {
      var i = e[o];
      if (void 0 !== i) return i.exports;
      var r = e[o] = {
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, n), r.exports;
    }
    return n.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), n(583);
  }();
});